import { INavigation } from '@/store/modules/history/types';

export const initNavigationData: INavigation = {
  start: 0,
  size: 20,
  direction: 'forward',
  isLastHistoryPage: false
};

export default initNavigationData;
